module.exports = __webpack_public_path__ + "img/index-main.cf492956.png";